import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import vs from '../images/Vs.png'
import redis from '../images/redis.png'
import git from '../images/git.png'
import github from '../images/github.png'
import npm from '../images/npm.png'
import js from '../images/js.png'
import redux from '../images/redux.png'
import html from '../images/html-5.svg'
import tailwind from '../images/tailwind.svg'
import vercel from '../images/vercel.svg'
import netlify from '../images/netlify.svg'
import heroku from '../images/heroku-icon.svg'
import mongodb  from '../images/mongodb2.png'
import express from '../images/express2.png'
import chakra from '../images/chakra.png'


import css from '../images/css-3.svg'
import react from '../images/react.png'
import { Link } from 'react-router-dom';
import Zoom from 'react-reveal/Zoom';

export default function Toolkit() {
    return (
        <div id = "skills">
            {/* <div className="mt-5 d-flex flex-row justify-content-center">
                <Link className="btn btn-primary me-3" to="/technicalSkill">Technical Skill</Link>
                <Link className="btn btn-primary me-3" to="/personalskill">Personal Skill</Link>
                <Link className="btn btn-primary " to="/toolkit">Toolkit</Link>
            </div> */}
            <Zoom left cascade>
            <h1 className="mt-4  aboutme-heading">Technologies i am fimilar with</h1>
            </Zoom>
            <Container className='mt-4'>
                <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={html} alt="" style={{width:'85%',height:'85%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={css} alt="" style={{width:'85%',height:'85%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={js} alt="" style={{width:'85%',height:'85%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={github} alt="" style={{width:'85%',height:'85%',filter: 'grayscale(1) invert(1)'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={git} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={tailwind} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={chakra} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={npm} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={react} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={redux} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={redis} alt="" style={{width:'95%',height:'95%'}}/>
                        
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={mongodb} alt="" style={{width:'105%',height:'125%'}}/>

                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={express} alt="" style={{width:'95%',height:'95%'}}/>

                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={vercel} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={netlify} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                    <Col xs={4} md={2} className="tech-icons">
                        <img src={heroku} alt="" style={{width:'95%',height:'95%'}}/>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
